import { defineMessages, FormattedMessage, useIntl } from 'react-intl'
import { useSelector } from 'react-redux'

// Utils
import { NEW_HOME } from '../../../../../constants/gems'

import { OVERLAY_HELPERS } from '../../../../../constants/navigation'

// Selectors
import { selectBuyerNewHomeBudgetWithCap } from '../../../../../store/selectors/home/equity/newHome'
import { selectNewHomeVideoThumbnail } from '../../../../../store/selectors/videos'

// Contexts
import { Box, Icon, Image, useTheme } from '@homebotapp/hb-react-component-catalog'

// Components
import { Format, Text } from '../../../..'
import { ImportantNowCard } from '../../ImportantNowCard'

// Assets
import DefaultThemeSvg from './DefaultThemeSvg'
import LightThemeSvg from './LightThemeSvg'

const newHomeMessages = defineMessages({
  nav: {
    id: 'ImportantNow.newHome.nav',
    defaultMessage: '\u25b6 Watch video'
  },
  thumbail: {
    id: 'ImportantNow.newHome.thumbnail',
    defaultMessage: 'Thumbnail for video on refinancing'
  }
})

const NewHome = () => {
  const budget = useSelector(selectBuyerNewHomeBudgetWithCap)
  const videoThumbnailUrl = useSelector(selectNewHomeVideoThumbnail)
  const { theme } = useTheme()

  const Svg = theme.isLightThemeType ? LightThemeSvg : DefaultThemeSvg
  const intl = useIntl()

  // creates video thumbnail component if it exists
  const VideoThumbnail = () => {
    if (!videoThumbnailUrl) return null
    return (
      <Box width='100%' margin='auto' position={'relative'}>
        <Image
          src={videoThumbnailUrl}
          alt={intl.formatMessage(newHomeMessages.thumbail)}
          width='100%'
          data-qa='new-home-video-thumbnail'
        />
        <Icon
          name='play'
          aria-hidden='true'
          boxSize={10}
          color='white'
          position='absolute'
          top='50%'
          left='50%'
          transform='translate(-50%, -50%)'
          cursor='pointer'
        />
      </Box>
    )
  }

  return (
    <>
      <ImportantNowCard
        winType='NewHome'
        navTo={OVERLAY_HELPERS.purchasing.buildPath(NEW_HOME)}
        svgImage={videoThumbnailUrl ? VideoThumbnail : Svg}
        navMessage={videoThumbnailUrl && intl.formatMessage(newHomeMessages.nav)}
        tracking={{
          guid: 'VxYoh7kWjgq7Lv5kRf7fB7X',
          ui_context: 'homeownerDashboardWinNewHome',
          descriptor: 'User clicked on New Home card in Whats Important Now section in Homeowner Dashboard'
        }}
      >
        <FormattedMessage
          id='ImportantNow.spotlight.dreamHome'
          defaultMessage='You might have up to {newHomeBudget} in purchasing power for a new home'
          values={{
            newHomeBudget: (
              <Text element='span' weight='semibold' variant='success' data-qa='win-new-home-budget-text'>
                <Format.Currency value={budget} abbreviate />
              </Text>
            )
          }}
        />
      </ImportantNowCard>
    </>
  )
}

export default NewHome
